<template>
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="120px">
      <!--添加物流中心-->
      <div class="common-form">添加</div>
      <el-form-item label="物流中心名称" prop="name" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.name" placeholder="请输入物流中心名称" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="物流中心区域">
        <el-table :data="areasRule" border style="width: 100%;">
          <el-table-column label="物流中心区域">
            <template slot-scope="scope">
              <div class="area-list">
                <span v-if="scope.row.citys.length == cityCount">全国</span>
                <span v-else v-for="(province, index) in scope.row.showData" :key="index" class="pr16">
                  {{ province.name }}
                  <template v-if="!province.isAllCitys">
                    (<span class="am-link-muted gray9">
                      <em v-for="(city, city_index) in province.citys" :key="city_index">
                        <span>{{ city.name }}</span><span v-if="(city_index + 1) < province.citys.length">、</span>
                      </em>
                    </span>)
                  </template>
                </span>
              </div>
              <a href="javascript:void(0);" @click="el=editAreaClick(scope.$index)">编辑</a>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="60px">
            <template slot-scope="scope">
              <a href="javascript:void(0);" @click="deleteAreaClick(scope.$index)">删除</a>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <el-button v-if="areasRule.length<1" @click="addAreaClick" type="text" size="small">+点击添加物流中心区域</el-button>
        </div>
      </el-form-item>

      <el-form-item label="物流中心简介">
        <el-input type="textarea" v-model="form.description" placeholder="请输入物流中心简介" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="物流中心排序">
        <el-input type="number" v-model="form.sort" placeholder="请输入物流中心排序" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="物流中心客服">
        <el-input type="text" v-model="form.customer" placeholder="物流中心客服" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="物流中心状态">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="0">禁用</el-radio>
        </el-radio-group>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
      <div class="common-form">管理员信息</div>

      <el-form-item label="管理员信息">
        <el-input type="number" v-model="form.user_name" placeholder="请输入手机号" class="max-w460">
          <template slot="append">
            @{{ app_id }}
          </template>
        </el-input>
      </el-form-item>

      <el-form-item label="管理员密码">
        <el-input type="password" v-model="form.password" placeholder="请输入登录密码" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="所属角色" prop="role_id">
        <el-select v-model="form.role_id" :multiple="true">
          <el-option v-for="item in roleList" :value="item.role_id" :key="item.role_id" :label="item.role_name_h1"></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <Areas v-if="show_area" :show_area="show_area" :areaModel="areaModel" :areas="options" @closeArea="closeAreaFunc"></Areas>
  </div>
</template>

<script>
import LogisticsApi from '@/api/logistics.js'
import Areas from './part/Area'
export default {
  components: {
    Areas: Areas,
  },
  data() {
    return {
      /*切换菜单*/
      // activeIndex: '1',
      /*form表单数据*/
      form: {
        name: '',
        description: '',
        sort: 1,
        status: 1,
        region: '',
        region_id: '',
        user_name: '',
        password: '',
        role_id: [],
        shop_user_id: 0,
        customer: '',
      },
      app_id: 0,
      roleList: [],
      loading: false,
      /*区域数据源*/
      options: [],
      /*区域数据源*/
      optionsMap: {},
      /*区域选中的model*/
      areaModel: {
        index: 0,
      },
      /*显示区域选中*/
      show_area: false,
      cityCount: 0,
      formData: [],
      areasRule: [],
    }
  },
  created() {
    /*引用的select_region 初始化*/
    // console.log(select_region);
    this.getData()
  },

  methods: {
    /*添加用户*/
    onSubmit() {
      let self = this
      let form = self.form
      self.$refs.form.validate((valid) => {
        if (valid) {
          self.loading = true
          LogisticsApi.addLogistics(form).then(data => {
              self.loading = false
              if (data.code == 1) {
                self.$message.success('恭喜你，添加成功')
                self.$router.push('/plus/logistics/index')
              } else {
                self.loading = false
              }
            })
            .catch(error => {
              self.loading = false
            })
        }
      })
    },

    getData() {
      let self = this
      LogisticsApi.addPrepare({}).then(data => {
        self.options = data.data.arr
        self.cityCount = data.data.cityCount
        self.app_id = data.data.app_id
        self.roleList = data.data.roleList
        //区域转数组
        self.options.forEach(function (area) {
          self.optionsMap[area.value] = area
        })
        if (!self.formData.length) return false
        self.formData.forEach(function (form) {
          // 转换为整数型
          for (let key in form.citys) {
            if (form.citys.hasOwnProperty(key)) {
              form.citys[key] = parseInt(form.citys[key])
            }
          }
          form['showData'] = self.getShowData({
            province: form.province,
            citys: form.citys,
          })
          self.areasRule.push(form)
        })
      }).catch(error => {
          console.log(error)
        })
    },

    // 格式化选中的区域id
    getShowData: function (checkedData) {
      let self = this
      let formData = {}
      checkedData.province.forEach(function (provinceId) {
        let province = self.optionsMap[provinceId],
          citys = [],
          cityCount = 0
        for (let cityIndex in province.children) {
          if (province.children.hasOwnProperty(cityIndex)) {
            let cityItem = province.children[cityIndex]
            if (self.inArray(cityItem.value, checkedData.citys)) {
              citys.push({
                id: cityItem.value,
                name: cityItem.label,
              })
            }
            cityCount++
          }
        }
        formData[province.value] = {
          id: province.value,
          name: province.label,
          citys: citys,
          isAllCitys: citys.length === cityCount,
        }
      })
      return formData
    },

    /*添加区域*/
    addAreaClick() {
      this.areaModel.index = this.areasRule.length
      this.areaModel.type = 'add'
      this.show_area = true
    },

    /*编辑区域*/
    editAreaClick(e) {
      this.areaModel.index = e
      this.areaModel.type = 'edit'
      this.show_area = true
    },

    /*关闭区域选中弹窗*/
    closeAreaFunc(e) {
      let self = this
      this.show_area = e.statu
      if (e.type != 'confirm') {
        return
      }
      this.options = e.this_area

      let provinces = []
      let citys = []
      e.this_area.forEach(function (province, index) {
        if ((province.checked == true || province.indeterminate == true) && province.index.indexOf(self.areaModel.index) != -1) {
          provinces.push(province['value'])
          province.children.forEach(function (city) {
            if (city.checked == true && city.index == self.areaModel.index) {
              citys.push(city['value'])
            }
          })
        }
      })
      this.form.region = citys.join(',')
      if (this.areaModel.type == 'add') {
        this.areasRule.push({
          citys: citys,
          showData: this.getShowData({
            province: provinces,
            citys: citys,
          }),
        })
      }
      if (this.areaModel.type == 'edit') {
        this.areasRule[this.areaModel.index]['showData'] = this.getShowData({
          province: provinces,
          citys: citys,
        })
        //设置rule的region
        this.areasRule[this.areaModel.index]['citys'] = citys
      }
      //更新表格变通做法
      this.areasRule.push([])
      this.areasRule.pop()
    },

    /*删除*/
    deleteAreaClick(e) {
      let self = this
      self.options.forEach(function (province) {
        if (self.inArray(province['value'], self.areasRule[e].province)) {
          province.checked = false
        }
        province.children.forEach(function (city) {
          if (self.inArray(city['value'], self.areasRule[e].citys)) {
            city.checked = false
          }
        })
      })
      self.areasRule.splice(e, 1)
    },

    // 数组中是否存在指定的值
    inArray: function (val, array) {
      return array.indexOf(val) > -1
    },

    /*取消*/
    cancelFunc() {
      this.$router.back(-1)
    },

  },

}
</script>

<style lang="scss" scoped>
  .basic-setting-content {}

  .product-add {
    padding-bottom: 50px;
  }

  .img {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/logistics/lists/add.vue